import { useState } from 'react';

/**
 * FAQItem — accessible accordion using a button + region pattern.
 * Plus icon rotates 45° (becomes ×) when open and fills with brand gradient.
 *
 * Props:
 *   q: question text
 *   a: answer text
 *   defaultOpen: boolean
 */
export default function FAQItem({ q, a, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className="border-t border-white/[.08] py-[22px] last:border-b transition-colors hover:bg-white/[.015]"
    >
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className={
          'w-full flex justify-between items-center text-left cursor-pointer ' +
          'font-display font-semibold text-base tracking-[-0.01em] text-ink-50 ' +
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue-bright/60 rounded-sm'
        }
      >
        <span>{q}</span>
        <span
          className={
            'w-7 h-7 grid place-items-center rounded-full flex-shrink-0 ml-4 ' +
            'border transition-[transform,background,color,border-color] duration-200 ' +
            (open
              ? 'bg-brand-gradient text-white border-transparent rotate-45 shadow-[0_6px_16px_-4px_rgba(59,130,246,.5)]'
              : 'bg-white/[.02] border-white/15 text-ink-200')
          }
          aria-hidden="true"
        >
          +
        </span>
      </button>
      <div
        className={`grid overflow-hidden transition-[grid-template-rows] duration-300 ${
          open ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className="overflow-hidden">
          <p className="mt-3.5 max-w-prose text-body-sm leading-[1.65] text-ink-200">{a}</p>
        </div>
      </div>
    </div>
  );
}
